import type { ComparisonConfig } from './ComparisonPage';

const OPERA_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io เทียบกับ Oracle OPERA',
  heroSubtitle: 'Oracle OPERA เป็นมาตรฐานอุตสาหกรรมรุ่นเก่า — สร้างมาหลายทศวรรษและยังคงมีความซับซ้อนและราคาระดับองค์กร HotelStack.io มอบทางเลือกคลาวด์เนทีฟทันสมัยพร้อมโมดูลมากกว่า ราคาง่ายกว่า และไม่ต้องดูแลโครงสร้างพื้นฐาน',
  overviewComparison: [
    { label: 'สถาปัตยกรรม', hotelstack: 'SaaS คลาวด์เนทีฟ', competitor: 'On-Premise รุ่นเก่า / คลาวด์' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: '$500+/เดือน + ใบอนุญาต' },
    { label: 'การติดตั้ง', hotelstack: 'ฟรี — เริ่มต้นใน 48 ชม.', competitor: 'ติดตั้ง 3-6 เดือน' },
    { label: 'โมดูลทั้งหมด', hotelstack: '36 ในตัว', competitor: '20+ (ใบอนุญาตแยก)' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ใบอนุญาต OPERA POS แยก' },
    { label: 'กลุ่มเป้าหมาย', hotelstack: 'SMB ถึงองค์กร', competitor: 'องค์กรเท่านั้น' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'การจัดการการจอง', hotelstack: true, competitor: true },
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: true },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: true },
        { name: 'การจัดการโฟลิโอแขก', hotelstack: true, competitor: true },
        { name: 'การจองแบบกลุ่ม', hotelstack: true, competitor: true },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: 'ส่วนเสริม' },
      ],
    },
    {
      category: 'คลาวด์และการเข้าถึง',
      features: [
        { name: 'คลาวด์เนทีฟแท้จริง', hotelstack: true, competitor: 'ไฮบริด' },
        { name: 'ไม่ต้องดูแลเซิร์ฟเวอร์', hotelstack: true, competitor: false },
        { name: 'ซิงค์หลายอุปกรณ์แบบเรียลไทม์', hotelstack: true, competitor: 'จำกัด' },
        { name: 'UI ตอบสนองทันสมัย', hotelstack: true, competitor: false },
        { name: 'อัปเดตอัตโนมัติ', hotelstack: true, competitor: false },
        { name: 'ไม่ต้องใช้ทีม IT', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'การจัดการรายได้',
      features: [
        { name: 'กฎการกำหนดราคาไดนามิก', hotelstack: true, competitor: true },
        { name: 'ตัวจำลองรายได้ What-If', hotelstack: true, competitor: false },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: 'ผ่าน Oracle BI' },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: true },
        { name: 'การวิเคราะห์ RevPAR', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'อาหารและเครื่องดื่ม & การดำเนินงาน',
      features: [
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: 'ใบอนุญาตแยก' },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: 'ใบอนุญาตแยก' },
        { name: 'ระบบแสดงผลครัว', hotelstack: true, competitor: false },
        { name: 'การจัดตารางพนักงาน', hotelstack: true, competitor: false },
        { name: 'ใบสั่งงานซ่อมบำรุง', hotelstack: true, competitor: 'ผ่านการเชื่อมต่อ' },
      ],
    },
    {
      category: 'ต้นทุนและการเริ่มต้นใช้งาน',
      features: [
        { name: 'เริ่มต้นใช้งานฟรี', hotelstack: true, competitor: false },
        { name: 'ย้ายข้อมูลฟรี', hotelstack: true, competitor: false },
        { name: 'ไม่มีค่าเซิร์ฟเวอร์', hotelstack: true, competitor: false },
        { name: 'ไม่มีค่าใบอนุญาต', hotelstack: true, competitor: false },
        { name: 'ราคาสกุลเงินท้องถิ่น', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: 'ส่วนเสริม' },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: 'ส่วนเสริม Micros' },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: 'ผ่านการเชื่อมต่อ' },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล ไม่มีค่าใบอนุญาต ไม่มีค่าเซิร์ฟเวอร์ เริ่มต้นใช้งานและย้ายข้อมูลฟรี ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB',
    competitorNote: 'ใบอนุญาตองค์กรจาก $500+/เดือนต่อสาขา ใบอนุญาต POS, S&C และ OCRM แยก ค่าติดตั้งจาก $50,000+ ต้องใช้เซิร์ฟเวอร์ On-Premise สำหรับรุ่นคลาสสิก',
  },
  advantages: [
    'ต้นทุนรวมของการเป็นเจ้าของต่ำกว่ากว่า 90% — ไม่มีค่าใบอนุญาต ค่าเซิร์ฟเวอร์ หรือค่าติดตั้ง',
    'เริ่มใช้งานจริงใน 48 ชั่วโมง เทียบกับระยะเวลาติดตั้ง OPERA 3-6 เดือน',
    'UI คลาวด์เนทีฟทันสมัยเข้าถึงได้จากทุกอุปกรณ์ — ไม่ต้องใช้ไคลเอนต์เดสก์ท็อป',
    'รวมทั้ง 36 โมดูลในสมาชิกสมาชิกเดียว เทียบกับใบอนุญาตโมดูล OPERA แยก',
    'ไม่ต้องมีโครงสร้างพื้นฐาน IT — ไม่ต้องมีเซิร์ฟเวอร์ แพตช์ หรือ Oracle DBA',
    'อาหารและเครื่องดื่มและ POS ในตัวไม่มีค่าใช้จ่ายเพิ่ม เทียบกับใบอนุญาต OPERA POS แยก',
    'ราคาตามภูมิภาคใน 6 สกุลเงิน โรงแรมจ่ายด้วยสกุลเงินท้องถิ่น',
    'ย้ายข้อมูลฟรีจาก OPERA พร้อมทีมสนับสนุนเฉพาะ',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'Oracle OPERA เป็นมาตรฐานอุตสาหกรรมมาหลายทศวรรษและยังคงเป็นทางเลือกที่ดีสำหรับเครือโรงแรมองค์กรขนาดใหญ่ที่มีโครงสร้างพื้นฐาน Oracle อยู่แล้ว อย่างไรก็ตามสำหรับโรงแรมส่วนใหญ่ HotelStack.io มอบโมดูลมากกว่า UX ดีกว่า และต้นทุนต่ำกว่าอย่างมาก โดยไม่ต้องมีวงจรการติดตั้งหลายเดือน ค่าดูแลเซิร์ฟเวอร์ และการอนุญาตใช้งานที่ซับซ้อนของ OPERA',
    bestFor: [
      'โรงแรมที่ต้องการลดค่าใบอนุญาตและโครงสร้างพื้นฐาน Oracle ที่แพง',
      'สถานที่ที่เบื่อกับวงจรการติดตั้งและอัปเกรด OPERA ที่ช้า',
      'โรงแรมที่ต้องการ UI คลาวด์เนทีฟทันสมัยไม่ต้องพึ่งไคลเอนต์เดสก์ท็อป',
      'โรงแรม SMB และขนาดกลางที่ราคา OPERA เกินงบ',
      'สถานที่ที่ต้องการรวมทุกโมดูลโดยไม่มีค่าใบอนุญาตแยก',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก Oracle OPERA มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมย้ายข้อมูลของเราเชี่ยวชาญการเปลี่ยนจาก OPERA สู่ HotelStack เราจะนำเข้าโปรไฟล์แขก ประวัติการจอง รหัสราคา การตั้งค่าห้อง และการจองกลุ่ม การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48-72 ชั่วโมงโดยไม่หยุดชะงัก' },
    { question: 'HotelStack.io รองรับการเชื่อมต่อเดียวกับ OPERA หรือไม่?', answer: 'HotelStack.io เชื่อมต่อกับกว่า 100 OTA, GDS ผ่าน Amadeus และ Sabre และช่องทางชำระเงินหลัก ตลาดการเชื่อมต่อของเราครอบคลุมระบบนิเวศเดียวกัน เรายังมี API แบบเปิดสำหรับการเชื่อมต่อแบบกำหนดเอง' },
    { question: 'HotelStack.io เปรียบเทียบกับ OPERA Cloud อย่างไร?', answer: 'OPERA Cloud คือ Oracle ที่กำลังปรับปรุงผลิตภัณฑ์รุ่นเก่า HotelStack.io ถูกสร้างเป็นคลาวด์เนทีฟตั้งแต่วันแรกด้วยเทคโนโลยีทันสมัย เรามีโมดูลมากกว่า (36 เทียบกับ OPERA Cloud พื้นฐาน) ราคาง่ายกว่า เริ่มต้นใช้งานเร็วกว่า และไม่ต้องพึ่งโครงสร้างพื้นฐาน Oracle' },
    { question: 'HotelStack.io เหมาะกับเครือโรงแรมขนาดใหญ่ที่ใช้ OPERA อยู่หรือไม่?', answer: 'ใช่ แผน Chain และ Enterprise ของเรารองรับการจัดการหลายสาขาพร้อมการวิเคราะห์ส่วนกลาง การจัดจำหน่ายราคา และมาตรฐานแบรนด์ — ความสามารถเดียวกันที่ทำให้เครือโรงแรมขนาดใหญ่ใช้ OPERA อยู่ ในราคาเพียงเศษเสี้ยว' },
  ],
};

const RMS_CLOUD_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io เทียบกับ RMS Cloud',
  heroSubtitle: 'RMS Cloud ให้บริการตลาดโรงแรม APAC ด้วยพื้นฐาน PMS ที่มั่นคง HotelStack.io ขยายขอบเขตด้วย 36 โมดูล ราคาหลายสกุลเงินทั่วโลก อาหารและเครื่องดื่ม/POS ในตัว และจัดการรายได้ขั้นสูง — ทั้งหมดในราคาที่ต่ำกว่า',
  overviewComparison: [
    { label: 'โมดูลทั้งหมด', hotelstack: '36 โมดูลแบบบูรณาการ', competitor: 'กว่า 12 โมดูล' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: 'เริ่มต้น $80+/เดือน' },
    { label: 'การเข้าถึงทั่วโลก', hotelstack: 'กว่า 40 ประเทศ', competitor: 'APAC เป็นหลัก' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ไม่มี' },
    { label: 'การจัดการรายได้', hotelstack: 'ขั้นสูง (ในตัว)', competitor: 'พื้นฐาน' },
    { label: 'ระบบจองห้อง', hotelstack: 'BookMyRoom.io (ฟรี)', competitor: 'วิดเจ็ตพื้นฐาน' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'PMS บนคลาวด์', hotelstack: true, competitor: true },
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: true },
        { name: 'การจัดการการจอง', hotelstack: true, competitor: true },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: true },
        { name: 'การจองแบบกลุ่ม', hotelstack: true, competitor: true },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: 'จำกัด' },
      ],
    },
    {
      category: 'รายได้และการจัดจำหน่าย',
      features: [
        { name: 'ตัวจัดการช่องทาง (กว่า 100 OTA)', hotelstack: true, competitor: 'OTA จำกัด' },
        { name: 'กฎการกำหนดราคาไดนามิก', hotelstack: true, competitor: false },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: false },
        { name: 'ตัวจำลองรายได้ What-If', hotelstack: true, competitor: false },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'การวิเคราะห์ RevPAR', hotelstack: true, competitor: 'พื้นฐาน' },
      ],
    },
    {
      category: 'การจัดการแขก',
      features: [
        { name: 'โปรไฟล์แขก 360 องศา', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'การจัดการโปรแกรมสะสมคะแนน', hotelstack: true, competitor: false },
        { name: 'ระบบอัตโนมัติสื่อสารกับแขก', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การวิเคราะห์การใช้จ่ายของแขก', hotelstack: true, competitor: false },
        { name: 'อัปโหลดและยืนยันตัวตน', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'อาหารและเครื่องดื่ม & การดำเนินงาน',
      features: [
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: false },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: false },
        { name: 'ระบบแสดงผลครัว', hotelstack: true, competitor: false },
        { name: 'การจัดการแม่บ้าน', hotelstack: true, competitor: true },
        { name: 'ใบสั่งงานซ่อมบำรุง', hotelstack: true, competitor: false },
        { name: 'การจัดตารางพนักงานและเงินเดือน', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'หลายสาขาและการปฏิบัติตามกฎหมาย',
      features: [
        { name: 'แดชบอร์ดเครือข่าย', hotelstack: true, competitor: true },
        { name: 'การวิเคราะห์ข้ามสาขา', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การออกบิลหลายสกุลเงิน', hotelstack: true, competitor: 'เน้น AUD' },
        { name: 'การปฏิบัติตามกฎหมายภาษีท้องถิ่น', hotelstack: true, competitor: 'APAC เท่านั้น' },
        { name: 'การคุ้มครองข้อมูล GDPR', hotelstack: true, competitor: 'จำกัด' },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: false },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: 'จำกัด' },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: false },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: false },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB เริ่มต้นใช้งานและย้ายข้อมูลฟรี',
    competitorNote: 'ราคาเป็น AUD จาก $80+/เดือน มีค่าใช้จ่ายเพิ่มสำหรับตัวจัดการช่องทางและฟีเจอร์พรีเมียม สนับสนุน APAC เป็นหลัก',
  },
  advantages: [
    'โมดูลมากกว่าเกือบสามเท่า (36 เทียบกับ 12+) พร้อมฟีเจอร์ทั้งหมดในราคาที่ต่ำกว่า',
    'ครอบคลุมทั่วโลกกว่า 40 ประเทศ เทียบกับ RMS Cloud ที่เน้นตลาด APAC',
    'โมดูลอาหารและเครื่องดื่มสมบูรณ์พร้อมเทอร์มินัล POS บริการห้องพัก และจัดการครัว',
    'จัดการรายได้ขั้นสูงพร้อมราคาไดนามิก การพยากรณ์ และตัวจำลอง',
    'เชื่อมต่อช่องทางที่แข็งแกร่งกว่าพร้อมกว่า 100 OTA และ GDS ผ่าน Amadeus และ Sabre',
    'จัดการพนักงานพร้อมจัดตาราง เงินเดือน เข้างาน และติดตามประสิทธิภาพ',
    'การออกบิลหลายสกุลเงินใน 6 สกุลเงิน เทียบกับราคาเป็น AUD เป็นหลัก',
    'เริ่มต้นใช้งานฟรีและย้ายข้อมูลพร้อมสนับสนุนเฉพาะ 24/7',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'RMS Cloud เป็น PMS ที่มีความสามารถสำหรับสถานที่ APAC พร้อมพื้นฐานที่มั่นคงสำหรับจัดการที่พัก HotelStack.io มอบโซลูชันที่ครอบคลุมกว่าด้วย 36 โมดูล การเข้าถึงทั่วโลก จัดการรายได้ขั้นสูง และความสามารถอาหารและเครื่องดื่ม/POS เต็มรูปแบบ — ทั้งหมดในราคาที่ต่ำกว่า สำหรับสถานที่ที่มองหาเกินกว่า PMS พื้นฐานสู่การจัดการดำเนินงานโรงแรมแบบครบวงจร HotelStack.io เป็นทางเลือกที่แข็งแกร่งกว่า',
    bestFor: [
      'โรงแรมที่ต้องการแพลตฟอร์มครบวงจรเกินกว่า PMS พื้นฐาน',
      'สถานที่ที่ต้องการอาหารและเครื่องดื่ม POS และจัดการครัวในตัว',
      'โรงแรมที่ขยายนอก APAC ต้องการการปฏิบัติตามกฎหมายและการจัดจำหน่ายทั่วโลก',
      'สถานที่ที่ต้องการจัดการรายได้ขั้นสูงและราคาไดนามิก',
      'เครือโรงแรมหลายสาขาที่ต้องการการวิเคราะห์ส่วนกลางข้ามสาขาทั่วโลก',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก RMS Cloud มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมย้ายข้อมูลของเราดำเนินการถ่ายโอนข้อมูลทั้งหมดจาก RMS Cloud รวมถึงโปรไฟล์แขก ประวัติการจอง การตั้งค่าราคา และการตั้งค่าห้อง การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48 ชั่วโมงโดยไม่หยุดชะงัก' },
    { question: 'HotelStack.io ทำงานได้ดีกับโรงแรมในออสเตรเลียและ APAC หรือไม่?', answer: 'แน่นอน HotelStack.io รองรับการออกบิลหลายสกุลเงินรวมถึง AUD การปฏิบัติตามกฎหมายภาษีท้องถิ่นสำหรับตลาด APAC และเชื่อมต่อกับ OTA ที่เน้น APAC สถานที่ APAC จำนวนมากเปลี่ยนมาจาก RMS Cloud เพื่อโมดูลเพิ่มเติมและการเข้าถึงทั่วโลก' },
    { question: 'ราคา HotelStack.io เปรียบเทียบกับ RMS Cloud อย่างไร?', answer: 'HotelStack.io เริ่มต้นที่ $49/เดือน พร้อมรวมทั้ง 36 โมดูลและราคาตามภูมิภาคใน 6 สกุลเงิน RMS Cloud เริ่มต้นที่ประมาณ $80+/เดือน AUD โดยมีโมดูลน้อยกว่าและค่าใช้จ่ายเพิ่มสำหรับจัดการช่องทางและฟีเจอร์พรีเมียม' },
    { question: 'HotelStack.io รองรับรีสอร์ทและแคมป์กราวด์เหมือน RMS Cloud หรือไม่?', answer: 'HotelStack.io ออกแบบมาสำหรับที่พักทุกประเภทรวมถึงโรงแรม รีสอร์ท โฮสเทล บูทีค และอพาร์ตเมนต์บริการ แม้ RMS Cloud จะมีฟีเจอร์เฉพาะสำหรับรีสอร์ท แต่ความยืดหยุ่นในการตั้งค่าของ HotelStack.io รองรับรูปแบบที่พักที่หลากหลาย' },
  ],
};

export const COMPARISON_TH_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_TH,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_TH,
};
